// @flow

export const partier = {
  R: {
    navn: 'Rødt',
    partilederNavn: 'Bjørnar Moxnes',
    bilde: 'https://snutt.nrk.no/multimedia_apps/partibarometer/images/R.jpg'
  },
  SV: {
    navn: 'Sosialistisk Venstreparti',
    partilederNavn: 'Audun Lysbakken',
    bilde: 'https://snutt.nrk.no/multimedia_apps/partibarometer/images/SV.jpg'
  },
  AP: {
    navn: 'Arbeiderpartiet',
    partilederNavn: 'Jonas Gahr Støre',
    bilde: 'https://snutt.nrk.no/multimedia_apps/partibarometer/images/AP.jpg'
  },
  SP: {
    navn: 'Senterpartiet',
    partilederNavn: 'Trygve Slagsvold Vedum',
    bilde: 'https://snutt.nrk.no/multimedia_apps/partibarometer/images/SP.jpg'
  },
  MDG: {
    navn: 'Miljøpartiet De Grønne',
    partilederNavn: 'Rasmus Hansson',
    bilde: 'https://snutt.nrk.no/multimedia_apps/partibarometer/images/MDG.jpg'
  },
  KRF: {
    navn: 'Kristelig Folkeparti',
    partilederNavn: 'Knut Arild Hareide',
    bilde: 'https://snutt.nrk.no/multimedia_apps/partibarometer/images/KRF.jpg'
  },
  V: {
    navn: 'Venstre',
    partilederNavn: 'Trine Skei Grande',
    bilde: 'https://snutt.nrk.no/multimedia_apps/partibarometer/images/V.jpg'
  },
  H: {
    navn: 'Høyre',
    partilederNavn: 'Erna Solberg',
    bilde: 'https://snutt.nrk.no/multimedia_apps/partibarometer/images/H.jpg'
  },
  FRP: {
    navn: 'Fremskrittspartiet',
    partilederNavn: 'Siv Jensen',
    bilde: 'https://snutt.nrk.no/multimedia_apps/partibarometer/images/FRP.jpg'
  }
}



// WEBPACK FOOTER //
// ./src/shared/data/index.js